import { useDispatch, useSelector } from "react-redux";
import profile_icon from "../../assets/img/user.png";
import { Star } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getNannyProfileById, clearData } from "../../store/apiSlice/NannyprofileByIdSlice";

const NannyProfileDisplay = ({ nannyId }) => {
    const dispatch = useDispatch();
    const profileData = useSelector((state) => state.rootReducer.nannyProfileByIdReducer.data);

    const [profile, setProfile] = useState({});

    useEffect(() => {
        dispatch(getNannyProfileById(nannyId));
        return () => dispatch(clearData());
    }, [nannyId]);

    useEffect(() => {
        if (profileData?.status === 1) {
            setProfile(profileData.data);
        }
    }, [profileData]);

    return (
        <div className="container py-4">
            {/* Profile Header */}
            <div className="text-center mb-5">
                <div
                    className="mx-auto mb-3"
                    style={{
                        width: "150px",
                        height: "150px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "3px solid #ddd",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                >
                    <img
                        src={profile.profileImage || profile_icon}
                        alt="Profile"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                </div>
                <h2 className="fw-bold mb-1">{profile.firstName} {profile.lastName}</h2>
                <div className="d-flex justify-content-center align-items-center gap-2">
                    <Star style={{ color: "#FFD700" }} />
                    <span>{profile.averageRating || "0"}</span>
                </div>
            </div>

            {/* Profile Details */}
            <div className="row">
                {[
                    { label: "First Name", value: profile.firstName },
                    { label: "Last Name", value: profile.lastName },
                    { label: "Date of Birth", value: profile.dateOfBirth },
                    { label: "Education", value: profile.education },
                    { label: "Family Background", value: profile.familyBackground },
                    { label: "Experience (Years)", value: profile.experienceOfYears },
                    { label: "Languages", value: profile.languages },
                    { label: "Do you have dog sitting experience?", value: profile.isGoodWithDogSitting ? "Yes" : "No" },
                    { label: "Do you smoke?", value: profile.isSmoker ? "Yes" : "No" },
                    { label: "Do you have a drivers license?", value: profile.isDrivingLicense ? "Yes" : "No" },
                    { label: "Do you own a car?", value: profile.isCarOwn ? "Yes" : "No" },
                    { label: "Do you mind cleaning up after the child or do light housekeeping?", value: profile.isCleaningUp ? "Yes" : "No" },
                    { label: "Do you have teaching experience?", value: profile.teachingExperience ? "Yes" : "No" },
                    { label: "Do you have new born baby experience?", value: profile.newBornExperience ? "Yes" : "No" },


                    { label: "Completed Jobs", value: profile.completedJobs || 0 },
                    // { label: "Ongoing Jobs", value: profile.onGoingJobs || 0 },
                    // { label: "Job Price (€)", value: profile.jobPrice || 0 },
                    // { label: "Service Time (hours)", value: profile.serviceTime || 0 },
                ].map((item, index) => (
                    <div key={index} className="col-md-6 mb-3">
                        <p className="mb-1 fw-semibold">{item.label}</p>
                        <p className="mb-0 text-muted">{item.value || "N/A"}</p>
                    </div>
                ))}

                {/* Address */}
                <div className="col-12 mt-4">
                    <p className="fw-semibold">Address</p>
                    <p className="text-muted">{profile.address || "No address available."}</p>
                </div>

                {/* Description / About */}
                <div className="col-12 mt-4">
                    <h5 className="fw-semibold text-theme">About</h5>
                    <p className="text-muted">{profile.description || "No description available."}</p>
                </div>

                {/* Childcare Experience */}
                <div className="col-12 mt-4">
                    <h5 className="fw-semibold text-theme">Childcare Experience</h5>
                    <p className="text-muted">{profile.childcareExperience || "No experience details available."}</p>
                    <p className="text-muted"><strong>Most Experienced Age Range:</strong> {profile.mostExperienceAge || "N/A"}</p>
                </div>

                {/* Skills */}
                {profile.skills?.length > 0 && (
                    <div className="col-12 mt-4">
                        <h5 className="fw-semibold text-theme">Skills</h5>
                        <ul className="list-unstyled">
                            {profile.skills.map((skill, idx) => (
                                <li
                                    key={idx}
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        color: "#1a73e8",
                                        padding: "8px 12px",
                                        marginBottom: "6px",
                                        borderRadius: "6px",
                                        display: "inline-block",
                                    }}
                                >
                                    {skill}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NannyProfileDisplay;
